export interface CreateInspectionRequest {
  branchCodes: {
    from: string
    to: string
    not: boolean
  }[]
  collectionTypes: {
    from: string
    to: string
    not: boolean
  }[]
  shelfTypes: {
    from: string
    to: string
    not: boolean
  }[]
}

export function CreateInspectionRequestToJSON(
  value: CreateInspectionRequest
): any {
  return {
    branch_codes:
      value.branchCodes.length > 0
        ? value.branchCodes.map(value => {
            return {
              from: value.from !== '' ? value.from : undefined,
              to: value.to !== '' ? value.to : undefined,
              not: value.not ?? undefined
            }
          })
        : undefined,
    collection_types:
      value.collectionTypes.length > 0
        ? value.collectionTypes.map(value => {
            return {
              from: value.from !== '' ? value.from : undefined,
              to: value.to !== '' ? value.to : undefined,
              not: value.not ?? undefined
            }
          })
        : undefined,
    shelf_types:
      value.shelfTypes.length > 0
        ? value.shelfTypes.map(value => {
            return {
              from: value.from !== '' ? value.from : undefined,
              to: value.to !== '' ? value.to : undefined,
              not: value.not ?? undefined
            }
          })
        : undefined
  }
}
